function utcToday() {
  return new Date().toISOString().slice(0, 10);
}

/**
 * Launch day: the cron opens access within a couple of minutes, but the page
 * will not notice on its own, so the caller can offer a refresh.
 */
export function isToday(date: string) {
  return date.slice(0, 10) === utcToday();
}

/**
 * `pendingAccessDate` arrives as a plain YYYY-MM-DD from the server, because
 * `deferred_until` is a DATE: reviving it as a JS Date and rendering it locally
 * shows the day before to every viewer west of UTC. Parse and format as UTC.
 *
 * Production Postgres runs UTC (verified 2026-08-29), so the "today" branch
 * compares the same clock the row was selected against.
 */
export function formatAccessDate(date: string) {
  const [y, m, d] = date.slice(0, 10).split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  if (Number.isNaN(dt.getTime())) {
    return date;
  }
  if (dt.toISOString().slice(0, 10) === utcToday()) {
    return 'today';
  }
  // Cohort offers are sold months ahead, so a bare "January 5" is ambiguous
  // once it crosses a year boundary.
  const sameYear = dt.getUTCFullYear() === new Date().getUTCFullYear();
  return dt.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: sameYear ? undefined : 'numeric',
    timeZone: 'UTC',
  });
}
